import { ReactElement } from "react";
import { IChartWrapperProps } from "../../types";
import BarChartWrapper from "./barChart";
import StackedBarChartWrapper from "./stackedBarChart";
import LineChartWrapper from "./lineChart";
import StackedLineChartWrapper from "./stackedLineChart";
import TreeMapChartWrapper from "./treeMapChart";
import RadarChartWrapper from "./radarChart";
import PieChartWrapper from "./pieChart";
import SummaryWrapper from "./summary";
import HeatMapChartWrapper from "./heatMapChart";

const MainWrapper = ({ cell, data, parentSize, palette, updatePalette, node, showAccumulated, schemas }: IChartWrapperProps): ReactElement => {

  switch (cell.chart) {
    case "BAR":
      return <BarChartWrapper cell={cell} data={data} parentSize={parentSize} palette={palette} updatePalette={updatePalette} node={node} showAccumulated={showAccumulated} schemas={schemas}/>;

    case "STACKED_BAR":
      return <StackedBarChartWrapper cell={cell} data={data} parentSize={parentSize} palette={palette} updatePalette={updatePalette} node={node} showAccumulated={showAccumulated}  schemas={schemas}/>;

    case "TREEMAP":
      return <TreeMapChartWrapper cell={cell} data={data} parentSize={parentSize} palette={palette} updatePalette={updatePalette} node={node} schemas={schemas}/>;

    case "RADAR":
      return <RadarChartWrapper cell={cell} data={data} parentSize={parentSize} palette={palette} updatePalette={updatePalette} node={node} schemas={schemas}/>;

    case "STACKED_LINE":
      return <StackedLineChartWrapper cell={cell} data={data} parentSize={parentSize} palette={palette} updatePalette={updatePalette} node={node} schemas={schemas}/>;

    case "LINE":
      return <LineChartWrapper cell={cell} data={data} parentSize={parentSize} palette={palette} updatePalette={updatePalette} node={node} schemas={schemas}/>;

    case "PIE":
      return <PieChartWrapper cell={cell} data={data} parentSize={parentSize} palette={palette} updatePalette={updatePalette} node={node} schemas={schemas}/>;

    case "HEATMAP":
      return <HeatMapChartWrapper cell={cell} data={data} parentSize={parentSize} palette={palette} updatePalette={updatePalette} node={node} schemas={schemas}/>;

    case "SUMMARY":
      return <SummaryWrapper cell={cell} data={data} parentSize={parentSize} palette={palette} updatePalette={updatePalette} node={node} schemas={schemas}/>;
  }

  return <div />;
};

export default MainWrapper;
